// /*eslint node/no-process-env: "off"*/

import device from "current-device"

import * as Path from "tslib/path"
import { assertNotEmpty } from "tslib/assert"

export default class Env {
    static readonly isMobile = device.mobile()
    static readonly isDesktop = device.desktop()
    static readonly isTablet = device.tablet()

    static readonly isLandscape = device.landscape()
    static readonly isPortrait = device.portrait()

    static readonly tokenUrl = false

    //
    // Convenience functions
    //
    static getOption(name: string, def: string): string {
        let val = process.env[name]
        return val ?? def
    }

    static requireOption(optName: string): string {
        let val = process.env[optName]
        assertNotEmpty(val, `.env missing: ${optName}`)
        return val!
    }

    static getAppOption(name: string, def: string): string {
        return Env.getOption("REACT_APP_" + name, def)
    }

    static requireAppOption(optName: string): string {
        return Env.requireOption("REACT_APP_" + optName)
    }

    //
    // Assets Locations
    //
    //static readonly publicUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '/';
    static readonly publicUrl = Env.getOption("PUBLIC_URL", "/")
    static readonly publicUrlImages = Path.makeFilePathRoot(
        Env.publicUrl,
        "images"
    )
    static makePublicImageUrl(...comps: string[]): string {
        return Path.makeFilePathRootArr(Env.publicUrlImages, comps)
    }

    //
    // Server API locations and setup
    //
    static readonly apiRoot = Env.getAppOption("API_ROOT", "api/v1")
}
